import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { descMaxLength, getHourSlots, nameMaxLength } from '../../Constant.js'
import axios from 'axios'
import { WaveLoading } from 'react-loadingg'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'
import CheckPermission from '../../common/Permissions/CheckPermission.js'

class StoreDetailsAdd extends React.Component {
  state = {
    shop_name_en: '',
    shop_desc_en: '',
    shop_name_ar: '',
    shop_desc_ar: '',
    shop_img: '',
    minimum_order_amount: '',
    shop_type: 'FOOD',
    shop_subscription_type: 'both',
    shop_min_hour: '',
    shop_end_time: '',
    shop_start_time: '',
    is_active: 'true',

    available_for_chalet: 'false',
    chalet_delivery_charge: 0,
    chalet_minimum_order_amount: 0,

    is_paydo_store: false,
    account_id: '',
    app_id: '',
    token: '',

    store_commission: '',
    pickup_list: [],
    store_id: '',
    isData: false,
    Edit: false,
    pickUpData: [],
    delivery_charge: {},
    ratings: 0,
    delivery_areas: [],
    delivery_areas_data: [],
    store_delivery_areas: [],
    excelFile: '',

    Store_list: [],

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',

    b2c_commission_type: '',
    b2b_commission_type: '',
    b2b_commission: '',
    b2c_commission: '',
    price_before_markup: '',
  }

  async componentDidMount() {
    await this.destinationList()
    await this.getDeliveryAreas()

    if (!(localStorage.getItem('loged_In_role') === 'store')) {
      this.getStoreDetails()
    }

    this.getStore()
  }

  getStore = async () => {
    await axios
      .get(Constant.getAPI() + '/store/list-stores', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res.data.success) {
          const matchItem = res?.data?.data?.filter((itm) => itm?.id === this.props?.storeDetail_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            var pickup_list = []
            if (typeof itm.pickup_list == 'string') {
              itm.pickup_list = JSON.parse(itm.pickup_list)
            }

            pickup_list = itm?.pickup_list?.map((it) => it?.pickupId)
            var pickUpDatatemp = [],
              pickUpData = []
            pickUpDatatemp = itm?.pickup_list?.map((it) => ({ charge: it?.charge }))

            var tem = this.state.Products_data?.map((itm) => ({
              pickupId: itm?.id,
              pickup_address_ar: itm?.pickup_address_ar,
              pickup_address_en: itm?.pickup_address_en,
            }))
            var res1 = tem?.filter((item) => pickup_list?.includes(item.pickupId))

            //                    var temp,t=[];
            for (let i = 0; i < res1?.length; i++) {
              for (let j = 0; j < itm?.pickup_list?.length; j++) {
                if (res1[i]?.pickupId === pickup_list[j]) {
                  res1[i].charge = pickUpDatatemp[j]?.charge
                }
              }
            }
            pickUpData = res1

            this.setState(() => ({
              ...itm,
              pickup_list,
              pickUpData,
            }))
            this.setState({ Edit: true })

            await this.getStoreDeliveryAreas()
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  exportDeliveryAreas = async () => {
    const storeId = this.props?.storeDetail_id
    await axios
      .get(Constant.getAPI() + '/admin/store-delivery-areas-excel-export?id=' + storeId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        const data = res.data.data

        this.exportFile = Constant.getImage() + data.file
        this.fileName = data.fileName
        const a = document.createElement('a')
        a.href = this.exportFile
        a.download = this.fileName
        a.click()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getStoreDeliveryAreas = async () => {
    const storeId = this.props?.storeDetail_id

    await axios
      .get(Constant.getAPI() + '/store/store-delivery-areas?id=' + storeId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const deliveryAreasdata = []
          const deliveryAreasSelected = []

          const data = res.data.data
          for (let item of data) {
            for (let deliveryArea of this.state.delivery_areas) {
              if (item.delivery_area_id == deliveryArea.id) {
                deliveryAreasdata.push({
                  charge: item.delivery_charge,
                  id: item.delivery_area_id,
                  name_en: deliveryArea.name_en,
                  name_ar: deliveryArea.name_ar,
                })

                deliveryAreasSelected.push(item.delivery_area_id)
                break
              }
            }
          }

          this.setState({
            ...this.state,
            delivery_areas_data: deliveryAreasdata,
            store_delivery_areas: deliveryAreasSelected,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  destinationList = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDeliveryAreas = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/city`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            delivery_areas: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getStoreDetails = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/list-users/store', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            Store_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event, pID) => {
    const { name, value } = event.target
    if (name === 'pickup_list') {
      this.setState(
        {
          pickup_list: value,
        },
        () => {
          let tempData = []

          this.state.pickUpData?.forEach((item) => {
            if (this.state.pickup_list.includes[item.pickupId]) {
              tempData.push(item)
            }
          })

          this.state.pickup_list.forEach((itm) => {
            let is_repeated = false

            tempData.forEach((item) => {
              if (item.pickupId == itm) {
                is_repeated = true
              }
            })

            if (!is_repeated) {
              let addPickup = this.state.Products_data.filter((item) => item.id === itm)
              tempData.push({
                charge: addPickup[0]?.pickup_vendor_charge,
                pickupId: addPickup[0]?.id,
                pickup_address_ar: addPickup[0]?.pickup_address_ar,
                pickup_address_en: addPickup[0]?.pickup_address_en,
              })
            }
          })

          this.setState({
            pickUpData: tempData,
          })
        }
      )
    } else if (name === 'store_delivery_areas') {
      if (!this.state.store_delivery_areas?.includes(value)) {
        const data = this.state.delivery_areas.filter((item) => item.id === value)
        this.setState({
          ...this.state,
          store_delivery_areas: [...this.state.store_delivery_areas, value],
          delivery_areas_data: [
            ...this.state.delivery_areas_data,
            {
              charge: 0,
              id: data[0]?.id,
              name_en: data[0]?.name_en,
              name_ar: data[0]?.name_ar,
            },
          ],
        })
      } else {
        const dataRemove = this.state.store_delivery_areas.filter((d) => d !== value)
        const removeItem = this.state.delivery_areas_data.filter((item) => item.id !== value)

        this.setState({
          ...this.state,
          store_delivery_areas: dataRemove,
          delivery_areas_data: removeItem,
        })
      }
    } else if (name === 'delivery_area_charge') {
      this.setState({
        ...this.state,
        delivery_areas_data: this.state.delivery_areas_data.map((data) => {
          return data?.id === pID ? { ...data, charge: Number(value) } : data
        }),
      })
    } else if (name === 'delivery_charge') {
      this.setState({
        ...this.state,
        pickUpData: this.state.pickUpData.map((data) => {
          return data?.pickupId === pID ? { ...data, charge: Number(value) } : data
        }),
      })
    } else if (name == 'ratings') {
      let rating = value

      if (rating < 0) {
        rating = 0
      } else if (rating > 5) {
        rating = 5
      }

      this.setState({
        ...this.state,
        [name]: rating,
      })
    } else {
      this.setState({
        ...this.state,
        [name]: value,
      })
    }
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }

  handleChangeVideo = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ video: URL.createObjectURL(e.target.files[0]) })
  }

  handleExcelChange = (e) => {
    const reader = new FileReader()
    if (e.target.files && e.target.files.length) {
      const file = e.target.files[0]
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        this.setState({
          excelFile: reader.result,
        })
      }
    } else {
      this.setState({
        excelFile: '',
      })
    }
  }

  onSaveData = async () => {
    var that = this

    if (this.state.b2b_commission_type && (!this.state.b2b_commission || this.state.b2b_commission == 0)) {
      document.getElementById('b2b_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2B commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    if (this.state.b2c_commission_type && (!this.state.b2c_commission || this.state.b2c_commission == 0)) {
      document.getElementById('b2c_commission')?.focus()
      that.setState({ isData: false })
      Swal.fire({
        title: 'B2C commission is required',
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    const formData = new FormData()

    // if (!(that.state.shop_start_time?.toString() <= that.state.shop_end_time?.toString())) {
    //   document.getElementById('shop_start_time')?.focus()
    //   that.setState({ isSaving: false })
    //   Swal.fire({
    //     title: 'Starting time Must be Greater Or Equal to end time',
    //     icon: 'error',
    //     text: '',
    //     type: 'error',
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Ok',
    //   })
    //   return false
    // }

    if (this.state.is_paydo_store && !this.state.account_id)
      return this.validateAndAlert(true, 'Account Id is required')
    if (this.state.is_paydo_store && !this.state.app_id) return this.validateAndAlert(true, 'App Id is required')
    if (this.state.is_paydo_store && !this.state.token) return this.validateAndAlert(true, 'Token is required')

    var tempData = []
    if (that.state.pickUpData?.length !== 0) {
      that.state.pickUpData?.forEach((itm) => {
        tempData = [...tempData, { charge: itm?.charge, pickupId: itm?.pickupId }]
      })
    }
    formData.append('shop_name_en', that.state.shop_name_en)
    formData.append('shop_desc_en', that.state.shop_desc_en)
    formData.append('shop_desc_ar', that.state.shop_desc_ar)
    formData.append('minimum_order_amount', that.state.minimum_order_amount)
    formData.append('shop_name_ar', that.state.shop_name_ar)
    formData.append('shop_end_time', that.state.shop_end_time)
    formData.append('shop_start_time', that.state.shop_start_time)
    formData.append('is_active', that.state.is_active)
    formData.append('shop_type', that.state.shop_type)
    formData.append('shop_subscription_type', that.state.shop_subscription_type)
    formData.append('shop_min_hour', that.state.shop_min_hour)
    formData.append('store_commission', that.state.store_commission)
    formData.append('pickup_list', JSON.stringify(tempData))
    formData.append('store_id', that.state.store_id)
    formData.append('ratings', that.state.ratings || 0)
    formData.append('delivery_areas', JSON.stringify(that.state.delivery_areas_data))

    formData.append('available_for_chalet', this.state.available_for_chalet)
    formData.append('chalet_delivery_charge', this.state.chalet_delivery_charge)
    formData.append('chalet_minimum_order_amount', this.state.chalet_minimum_order_amount)
    formData.append('is_paydo_store', this.state.is_paydo_store)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    formData.append('b2b_commission_type', this.state.b2b_commission_type || '')
    formData.append('b2b_commission', this.state.b2b_commission || '')
    formData.append('b2c_commission_type', this.state.b2c_commission_type || '')
    formData.append('b2c_commission', this.state.b2c_commission || '')
    formData.append('price_before_markup', this.state.price_before_markup || '')

    if (this.state.is_paydo_store) {
      formData.append('account_id', this.state.account_id)
      formData.append('app_id', this.state.app_id)
      formData.append('token', this.state.token)
    }

    that.setState({ isData: true })

    if (that.props.storeDetail_id) {
      formData.append('cat_id', that.props.storeDetail_id)
      if (that.state.shop_img?.name) {
        formData.append('shop_img', that.state.shop_img)
      }
      if (that.state.video_url?.name) {
        formData.append('video_url', that.state.video_url)
      }
      await axios
        .post(Constant.getAPI() + '/store/update-store-details', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Store Details Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = '#/store-details'
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      formData.append('shop_img', this.state.shop_img)
      await axios
        .post(Constant.getAPI() + '/store/add-store-details', formData, {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          Swal.fire({
            title: 'StoreDetails Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          that.setState({ isData: false })
          window.location.href = '#/store-details'
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  validateAndAlert = (condition, errorMessage) => {
    if (condition) {
      this.setState({ isSaving: false })
      Swal.fire({
        title: errorMessage,
        icon: 'error',
        text: '',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    return true
  }

  submitExcel = async () => {
    var that = this
    if (that.props.storeDetail_id && that.state.excelFile) {
      that.setState({ isUploading: true })
      const data = {
        file: that.state.excelFile,
        store_id: that.props.storeDetail_id,
      }
      await axios
        .post(Constant.getAPI() + '/admin/store-delivery-areas-excel-import', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.setState(
            {
              isUploading: false,
              excelFile: '',
            },
            () => {
              this.image_excel.value = null
            }
          )

          Swal.fire({
            title: 'Delivery Area details Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          // window.location.href = "#/store-details";
        })
        .catch((err) => {
          that.setState({ isUploading: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        {this.state.isUploading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label
                  className="col-sm-3 col-form-label"
                  style={{ fontWeight: 'bold' }}
                >
                  Type
                </label>
                <div className="col-sm-9">
                  <select
                    name="shop_type"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.shop_type}
                  >
                    <option value="FOOD">Food</option>
                    <option value="STORE">Store</option>
                    <option value="CATERING">Catering</option>
                    {/* <option value="CARSERVICE">Car Service</option> */}
                    {/* <option value="OCCASSION">Occassion</option> */}
                  </select>
                </div>
              </div>
            </div>

            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            ></div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="shop_name_en"
                    id="shop_name_en"
                    placeholder="Shop Name: English"
                    onChange={this.handleChange}
                    value={this.state.shop_name_en}
                    maxLength={nameMaxLength}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.shop_name_en
                    ? this.state.shop_name_en.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Name: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="shop_name_ar"
                    id="shop_name_ar"
                    placeholder="Shop Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.shop_name_ar}
                    maxLength={nameMaxLength}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.shop_name_ar
                    ? this.state.shop_name_ar.length + ' / ' + nameMaxLength
                    : 0 + ' / ' + nameMaxLength}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description Name: English</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="shop_desc_en"
                    id="shop_desc_en"
                    placeholder="Description Name: English"
                    value={this.state.shop_desc_en}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.shop_desc_en
                    ? this.state.shop_desc_en.length + ' / ' + descMaxLength
                    : 0 + ' / ' + descMaxLength}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Description Name: Arabic</label>
                <div className="col-sm-9">
                  <textarea
                    rows={4}
                    className="form-control"
                    name="shop_desc_ar"
                    id="shop_desc_ar"
                    placeholder="Description Name: Arabic"
                    value={this.state.shop_desc_ar}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col-sm-12 text-right">
                  {this.state.shop_desc_ar
                    ? this.state.shop_desc_ar.length + ' / ' + descMaxLength
                    : 0 + ' / ' + descMaxLength}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Supplier List</label>
                <div className="col-sm-9">
                  <select
                    name="store_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.store_id}
                  >
                    <option>Select Store Supplier</option>
                    {this.state?.Store_list?.length > 0 &&
                      this.state.Store_list?.map((itm) => (
                        <option
                          value={itm.id}
                          key={itm.id}
                        >
                          {itm.first_name} {itm.last_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            {['STORE', 'CATERING'].includes(this.state.shop_type) && (
              <>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Subscription Type</label>
                    <div className="col-sm-9">
                      <select
                        name="shop_subscription_type"
                        className="form-control"
                        onChange={this.handleChange}
                        value={this.state.shop_subscription_type}
                      >
                        <option value="both">All</option>
                        <option value="additional_item">Additional Items Only</option>
                        <option value="store_order">Store Order Only</option>
                      </select>
                    </div>
                  </div>
                </div>

                {!this.props?.storeDetail_id &&
                  (this.state.shop_subscription_type == 'both' ||
                    this.state.shop_subscription_type == 'store_order') && (
                    <div
                      className="col-md-12"
                      style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                    >
                      <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                        Store Order Settings:- Upload Delivery Areas
                      </div>
                      <div style={{ marginTop: 10, fontSize: 15, color: 'red' }}>
                        This section details(Delivery Area) can be added after adding stores in the system
                      </div>
                    </div>
                  )}

                {this.props?.storeDetail_id &&
                  (this.state.shop_subscription_type == 'both' ||
                    this.state.shop_subscription_type == 'store_order') && (
                    <>
                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      >
                        <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                          Store Order Settings:- Upload Delivery Areas
                          <button
                            onClick={this.exportDeliveryAreas}
                            className="btn btn-grd-disabled float-right"
                          >
                            Export Delivery Areas
                          </button>
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ marginBottom: 20 }}
                      >
                        <div className="row">
                          <div className="col-sm-2">Excel File</div>
                          <div className="col-sm-7">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="excel_file"
                                  name="excel_file"
                                  accept=".xls,.xlsx"
                                  className="w-100"
                                  onChange={this.handleExcelChange}
                                  ref={(ref) => (this.image_excel = ref)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            {this.state.excelFile ? (
                              this.state.isUploading ? (
                                <button className="btn btn-disabled float-right">Uploading...</button>
                              ) : (
                                <button
                                  onClick={this.submitExcel}
                                  className="btn btn-grd-disabled float-right"
                                >
                                  Upload
                                </button>
                              )
                            ) : (
                              <button className="btn btn-disabled float-right">Upload</button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
              </>
            )}

            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Commission</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2b_commission_type"
                    className="form-control"
                    value={this.state.b2b_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2B Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2b_commission"
                    id="b2b_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2b_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission Type</label>
                <div className="col-sm-9">
                  <select
                    name="b2c_commission_type"
                    className="form-control"
                    value={this.state.b2c_commission_type}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Option</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">B2C Commission</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="b2c_commission"
                    id="b2c_commission"
                    // placeholder="In percentage 1 to 100"
                    value={this.state.b2c_commission}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Before Markup</label>
                <div className="col-sm-9">
                  <input
                    className="form-control"
                    type="number"
                    onChange={this.handleChange}
                    name="price_before_markup"
                    id="price_before_markup"
                    placeholder="Price Before Markup"
                    value={this.state.price_before_markup}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Additional Items Settings</div>
            </div>

            {/* <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Commision %</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="store_commission"
                    id="store_commission"
                    placeholder="Store commision"
                    onChange={this.handleChange}
                    value={this.state.store_commission}
                  />
                </div>
              </div>
            </div> */}

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Minimum order amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="minimum_order_amount"
                    id="minimum_order_amount"
                    placeholder="minimum order amount"
                    onChange={this.handleChange}
                    value={this.state.minimum_order_amount}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Min Hours</label>
                <div className="col-sm-9">
                  <select
                    name="shop_min_hour"
                    className="form-control"
                    value={this.state.shop_min_hour}
                    onChange={this.handleChange}
                  >
                    <option>Select time</option>
                    {getHourSlots().map(
                      (itm) => itm.value != '00:00:00' && <option value={itm.value}>{itm.label}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Start Time</label>
                <div className="col-sm-9">
                  <select
                    name="shop_start_time"
                    className="form-control"
                    value={this.state.shop_start_time}
                    onChange={this.handleChange}
                  >
                    <option>Select Start time(HH:MM)</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value}>{itm.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">End Time</label>
                <div className="col-sm-9">
                  <select
                    name="shop_end_time"
                    className="form-control"
                    value={this.state.shop_end_time}
                    onChange={this.handleChange}
                  >
                    <option>Select End time(HH:MM)</option>
                    {getHourSlots().map((itm) => (
                      <option value={itm.value}>{itm.label}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <GroupCheckbox
                title={'Pickup list'}
                list={this.state.Products_data || []}
                displayKey={'pickup_address_en'}
                idKey={'id'}
                selected={this.state.pickup_list}
                onChange={(selected) => {
                  this.handleChange({
                    target: {
                      name: 'pickup_list',
                      value: selected,
                    },
                  })
                }}
              ></GroupCheckbox>
            </div>

            {this.state.pickUpData?.length > 0
              ? this.state.pickUpData?.map((itm) => {
                  return (
                    <div
                      className="col-md-6"
                      key={itm?.pickupId}
                    >
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Delivary Charge {itm?.pickup_address_en} / {itm?.pickup_address_ar}
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            name="delivery_charge"
                            className="form-control"
                            onChange={(event) => this.handleChange(event, itm?.pickupId)}
                            //  value={this.state.pickUpData[itm.charge]}
                            value={itm?.charge}
                          />
                        </div>
                      </div>
                    </div>
                  )
                })
              : ''}
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Chalet Settings</div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Available for Chalet</label>
                <div className="col-sm-9">
                  <Toggle
                    id="available_for_chalet"
                    name="available_for_chalet"
                    checked={this.state.available_for_chalet == true ? true : false}
                    onChange={() => {
                      this.setState({
                        available_for_chalet: !this.state.available_for_chalet,
                      })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Chalet Delivary charge</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Amount"
                    value={this.state.chalet_delivery_charge}
                    name="chalet_delivery_charge"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Chalet Min Order Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Amount"
                    value={this.state.chalet_minimum_order_amount}
                    name="chalet_minimum_order_amount"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            {localStorage.getItem('loged_In_role') === 'super-admin' && (
              <>
                <div
                  className="col-md-12"
                  style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                >
                  <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>Paydo store Settings</div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Paydo Store</label>
                    <div className="col-sm-9">
                      <Toggle
                        id="is_paydo_store"
                        name="is_paydo_store"
                        checked={this.state.is_paydo_store == true ? true : false}
                        onChange={() => {
                          this.setState({
                            is_paydo_store: !this.state.is_paydo_store,
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
                {this.state.is_paydo_store && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Account Id</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Account Id"
                            value={this.state.account_id}
                            name="account_id"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">App Id</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter App Id"
                            value={this.state.app_id}
                            name="app_id"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Token</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Token"
                            value={this.state.token}
                            name="token"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            <div
              className="col-md-12"
              style={{ borderBottom: '2px solid #eee', marginBottom: 20 }}
            ></div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="is_active"
                    className="form-control"
                    value={this.state.is_active}
                    onChange={this.handleChange}
                  >
                    <option value="true">Active</option>
                    <option value="false"> InActive </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Ratings</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="ratings"
                    id="ratings"
                    placeholder="Ratings"
                    onChange={this.handleChange}
                    value={this.state.ratings}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="shop_img"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.img ? (
                    <img
                      width="200px"
                      height="150px"
                      src={this.state.img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : this.state.Edit && this.state.shop_img ? (
                    <img
                      width="200px"
                      height="150px"
                      src={Constant.getImage() + this.state.shop_img}
                      alt="img"
                      onError={({ currentTarget }) => {
                        currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Video</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="video"
                        name="video_url"
                        accept="video/*"
                        className="w-100"
                        onChange={this.handleChangeVideo}
                      />
                    </div>
                  </div>
                  {this.state.video ? (
                    <video
                      width="200px"
                      height="150px"
                      controls
                      src={this.state.video}
                    />
                  ) : this.state.Edit && this.state.video_url ? (
                    <video
                      width="200px"
                      height="150px"
                      controls
                      src={Constant.getImage() + this.state.video_url}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder="Meta Title: English"
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder="Meta Title: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder="Meta keywords: English"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder="Meta keywords: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      placeholder="Meta Description: English"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      placeholder="Meta Description: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
          </div>

          <div className="row float-right p-3">
            {this.state.isData ? (
              <button
                className="btn btn-grd-disabled mr-2"
                disabled
              >
                Saving...!
              </button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={'/store-details'}
              className="btn btn-outline-dark"
            >
              {' '}
              Cancel{' '}
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreDetailsAdd
